module.exports = __webpack_public_path__ + "img/success_icon.32d7f5b2.png";